enum DataSource {
  MEDIAN_INCOME = "medianIncome",
  POPULATION = "population",
}

export default DataSource;
